export const trainings = [
  // {
  //   name: "BRIGADA 8h",
  //   value: "BRIGADA 8H",
  //   miniature: "BRIGADA 8H",
  // },
  {
    name: "BRIGADA 16H / 24H",
    value: "BRIGADA 16H",
    miniature: "BRIGADA 16H",
  },
  {
    name: "NR 7 - PRIMEIROS SOCORROS PRESENCIAL",
    value: "BRIGADA PS",
    miniature: "BRIGADA PS",
  },
  {
    name: "DIREÇÃO DEFENSIVA EAD",
    value: "DP",
    miniature: "DP",
  },
  {
    name: "NR 05 - CIPA",
    value: "NR 05",
    miniature: "NR 05",
  },
  // {
  //   name: "NR 06 - EPI, PCA E PPR",
  //   value: "NR 06",
  //   miniature: "NR 06",
  // },
  {
    name: "NR 06 - EPI - EAD",
    value: "NR 06 - EPI - EAD",
    miniature: "NR 06",
  },
  {
    name: "NR 10 - SERVIÇOS EM ELÉTRICA",
    value: "NR 10",
    miniature: "NR 10",
  },
  // {
  //   name: "NR 11 E 12 - EMPILHADEIRA",
  //   value: "NR 11 e 12",
  //   miniature: "NR 11 e 12",
  // },
  // {
  //   name: "NR 11 - PONTE ROLANTE",
  //   value: "NR 11",
  //   miniature: "NR 11",
  // },
  {
    name: "NR 11 - EMPILHADEIRA - 08H RECICLAGEM",
    value: "NR 11 - EMPILHADEIRA - 08H RECICLAGEM",
    miniature: "NR 11",
  },
  {
    name: "NR 11 - EMPILHADEIRA - 16H FORMAÇÃO",
    value: "NR 11 - EMPILHADEIRA - 16H INICIAL",
    miniature: "NR 11",
  },
  {
    name: "NR 11 - PONTE ROLANTE - 08H - RECICLAGEM",
    value: "NR 11 - PONTE ROLANTE - 08H - RECICLAGEM",
    miniature: "NR 11",
  },
  {
    name: "NR 11 - PONTE ROLANTE 16H – FORMAÇÃO",
    value: "NR 11 - PONTE ROLANTE 16H - INICIAL",
    miniature: "NR 11",
  },
  {
    name: "NR 12 E 18 - ROMPEDOR",
    value: "NR 12 e 18",
    miniature: "NR 12 e 18",
  },
  {
    name: "NR 12 - ROÇADEIRA",
    value: "NR 12",
    miniature: "NR 12",
  },
  {
    name: "NR 12 – MÁQUINAS E EQUIPAMENTOS – PRESENCIAL",
    value: "NR 12 EP",
    miniature: "NR 12 EP",
  },
  {
    name: "NR 18 ANDAIME - 40h - PRESENCIAL",
    value: "NR 18",
    miniature: "NR 18",
  },
  {
    name: "NR 18 SEGURANÇA EM OBRAS – PRESENCIAL",
    value: "NR 18 SIN",
    miniature: "NR 18",
  },
  {
    name: "NR 20 - 04H EAD",
    value: "NR 20 - 04H EAD",
    miniature: "NR 20",
  },
  {
    name: "NR 20 - 04H PRESENCIAL",
    value: "NR 20 - 04H PRESENCIAL",
    miniature: "NR 20",
  },
  // ead
  {
    name: "NR 33 - 16H – FORMAÇÃO – PRESENCIAL",
    value: "NR 33 - INICIAL - 16H",
    miniature: "NR 33",
  },
  {
    name: "NR 33 - EAD - 16H",
    value: "NR 33 - EAD - 16H",
    miniature: "NR 33",
  },
  {
    name: "NR 33 - PRÁTICO - 04H",
    value: "NR 33 - PRÁTICO - 04H",
    miniature: "NR 33",
  },
  {
    name: "NR 33 - 08H – RECICLAGEM – PRESENCIAL",
    value: "NR 33 - RECICLAGEM - 08H",
    miniature: "NR 33",
  },
  {
    name: "NR 33 - SUPERVISOR INICIAL - 40H",
    value: "NR 33 - SUPERVISOR INICIAL - 40H",
    miniature: "NR 33",
  },
  {
    name: "NR 33 - SUPERVISOR RECICLAGEM - 08H",
    value: "NR 33 - SUPERVISOR RECICLAGEM - 08H",
    miniature: "NR 33",
  },
  // {
  //   name: "NR 34 - TRABALHO A QUENTE",
  //   value: "NR 34",
  //   miniature: "NR 34",
  // },
  {
    name: "NR 34 - TRAB. A QUENTE - 08H - PRESENCIAL",
    value: "NR 34 - TRAB. A QUENTE - 08H",
    miniature: "NR 34",
  },
  {
    name: "NR 35 – 08H – PRESENCIAL",
    value: "NR 35 - 08H",
    miniature: "NR 35",
  },
  {
    name: "NR 35 - PRÁTICO 4H",
    value: "NR 35 - PRÁTICO 4H",
    miniature: "NR 35",
  },
  {
    name: "NR 18 - PEMT – 08H - PRESENCIAL",
    value: "NR 18 - PEMT – 08H - PRESENCIAL",
    miniature: "NR 18",
  },
  {
    name: "NR 18 SEGURANÇA EM OBRAS – 10H – EAD",
    value: "NR 18 SEGURANÇA EM OBRAS – 10H – EAD",
    miniature: "NR 18",
  },
  {
    name: "NR 7 - PRIMEIROS SOCORROS – 04 H EAD",
    value: "NR 7 - PRIMEIROS SOCORROS – 04 H EAD",
    miniature: "BRIGADA PS",
  },
  {
    name: "NR 12 – MÁQUINAS E EQUIPAMENTOS – 08H EAD",
    value: "NR 12 – MÁQUINAS E EQUIPAMENTOS – 08H EAD",
    miniature: "NR 12",
  },
  {
    name: "NR 33 - 16H – FORMAÇÃO – EAD",
    value: "NR 33 - 16H – FORMAÇÃO – EAD",
    miniature: "NR 33",
  },
  {
    name: "NR 35 – 08H – EAD",
    value: "NR 35 – 08H – EAD",
    miniature: "NR 35",
  },
  {
    name: "NR 18 - INTEGRAÇÃO – 08H – EAD",
    value: "NR 18 - INTEGRAÇÃO – 08H – EAD",
    miniature: "NR 18",
  },
  {
    name: "NR 18 - ANDAIME - 40H EAD",
    value: "NR 18 - ANDAIME - 40H EAD",
    miniature: "NR 18",
  },
  {
    name: "BRIGADA 4h",
    value: "BRIGADA 4H",
    miniature: "BRIGADA 16H",
  },
  {
    name: "NR 34 HIDROJATO - 08H – PRESENCIAL",
    value: "NR 34 HIDROJATO - 08H – PRESENCIAL",
    miniature: "NR 34",
  },
];

export const description = [
  {
    name: "BRIGADA 4H",
    value:
      " concluiu com aproveitamento o treinamento de Formação de Brigadistas de acordo com a IT 17, NBR 14276 e NR 23, com carga horária de 4 horas. Realizado no dia ((07 de mês de ano)), nas dependências da empresa ((Casa do Adubo - Unidade de Pilar do Sul)).",
  },
  {
    name: "NR 18 - ANDAIME - 40H EAD",
    value:
      " concluiu com aproveitamento o treinamento de Formação em Segurança do Trabalho na montagem e desmontagem de andaimes nas modalidades: Andaimes multidirecionais, encaixe e tubos Rohr, de acordo com a NR 18, realizado em ensino a distância (EAD) no dias ((07, 08, 09, 10 e 11 de MÊS de ANO)), com carga horária de 40 horas",
  },
  {
    name: "NR 34 HIDROJATO - 08H – PRESENCIAL",
    value:
      " concluiu com aproveitamento o treinamento de Saúde e Segurança na Operação de bomba de alta pressão de acordo com a NR 34, com carga horária de 08 horas. Realizado presencialmente no dia (( xx )) de (( xxxx )) de 20xx, em (( cidade ))",
  },
  {
    name: "NR 18 - INTEGRAÇÃO – 08H – EAD",
    value:
      " concluiu com aproveitamento o Treinamento de Integração em Saúde, Segurança e Meio Ambiente para Trabalho na Construção Civil, de acordo com a NR 18 e 21, com carga horária de 08 horas. Realizado em ((20 de MÊS de ANO))",
  },
  {
    name: "NR 35 – 08H – EAD",
    value:
      " concluiu com aproveitamento o treinamento de Saúde e Segurança nos Trabalhos em Altura de acordo com a NR 35, com carga horária de 08 horas. Realizado em 14 de maio de 2026",
  },
  {
    name: "NR 33 - 16H – FORMAÇÃO – EAD",
    value:
      " concluiu com aproveitamento o treinamento de formação em Saúde e Segurança nos Espaços Confinados segundo a NR 33, com carga horária total de 16 horas. Realizado via Ensino a Distância nos dias ((21 e 22 de mês de ano))",
  },
  {
    name: "NR 12 – MÁQUINAS E EQUIPAMENTOS – 08H EAD",
    value:
      " concluiu com aproveitamento o treinamento de Saúde e Segurança do Trabalho na Operação de Máquinas e Equipamentos de acordo com as NR’s 12, com carga horária de 08 horas. Realizado em ((07 de mês de ano))",
  },
  {
    name: "NR 7 - PRIMEIROS SOCORROS – 04 H EAD",
    value:
      " concluiu com aproveitamento o treinamento EAD de Noções de Primeiros Socorros para Atendimento de Emergência de acordo com NR 07, e com carga horária de 04 horas. Realizado em ((16 de mês de ano.))",
  },
  {
    name: "NR 18 SEGURANÇA EM OBRAS – 10H – EAD",
    value:
      " concluiu com aproveitamento o Treinamento de Saúde e Segurança em Obras, Sinalização de Segurança e Identificação de Riscos em Canteiros, de acordo com a NR 18 e com carga horária de 10 horas. Realizado em ((20 de mês de 2026.))",
  },
  {
    name: "NR 18 - PEMT – 08H - PRESENCIAL",
    value:
      " concluiu com aproveitamento o treinamento de Plataforma Elevatória Móvel de Trabalho (PEMT) de acordo com a NR 18, com carga horária de 8 horas. Realizado no dia ((07 de mês de ano)), nas dependências da empresa ((Casa do Adubo - Unidade de Pilar do Sul)).",
  },
  {
    name: "BRIGADA 16H",
    value:
      " concluiu com aproveitamento o treinamento de Formação de Brigadistas de acordo com a IT 17, NBR 14276 e NR 23, com carga horária de {{ 16 ou 24 }} horas. Realizado nos dias ((07 e 08 de mês de ano)), nas dependências da empresa ((Casa do Adubo - Unidade de Pilar do Sul)).",
  },
  {
    name: "BRIGADA PS",
    value:
      " concluiu com aproveitamento o treinamento prático de Primeiros Socorros de acordo com a NR 07 e com carga horária de ((04 horas)). Realizado no dia ((10 de xxxx de 20xx)), nas dependências da empresa ((xxx))",
  },
  {
    name: "DP",
    value:
      " concluiu com aproveitamento o Treinamento de Direção Preventiva para veículos leves de acordo com o código de trânsito brasileiro, realizado no dia ((18 de janeiro de 2025)) com carga horária de 04 horas.",
  },
  {
    name: "NR 05",
    value:
      " concluiu com aproveitamento o treinamento  de Comissão Interna de Prevenção de Acidentes - CIPA de acordo com a NR 05, realizado nos dias ((12, 13 e 14 de abril de 2025)), com carga horária de 20 horas.",
  },
  // {
  //   name: "NR 06",
  //   value:
  //     " concluiu com aproveitamento o treinamento Uso, Guarda e Conservação de EPI’s de acordo com a NR 06, realizado em ((14 de setembro de 2024)) com carga horária de 02 horas.",
  // },
  {
    name: "NR 06 - EPI - EAD",
    value:
      "  concluiu com aproveitamento o treinamento Uso, Guarda e Conservação de EPI’s e EPC's de acordo com a NR-06, carga horária de 02 horas. Realizado em ((23 de julho de 2025)).",
  },
  {
    name: "NR 10",
    value:
      " concluiu com aproveitamento o Curso Básico de NR-10, Saúde e Segurança em Instalações e Serviços em Eletricidade, com carga horária de 40 horas de acordo com o Item 10.8 e Anexo III da NR-10. Realizado do dia ((04 até 08 de agosto de 2025)).",
  },
  // {
  //   name: "NR 11 e 12",
  //   value:
  //     " concluiu com aproveitamento o treinamento de formação em Segurança na Operação de Empilhadeiras de acordo com as NR’s 11 e 12, realizado em ((30 de maio e 02 de junho de 2025)) com carga horária de 16 horas.",
  // },
  // {
  //   name: "NR 11",
  //   value:
  //     " concluiu com aproveitamento o treinamento de formação em Segurança na operação de Pórticos, Pontes rolantes, Monovias, e Talhas Elétricas de acordo com a NR 11, realizado em ((06 e 07 de maio de 2025)), com carga horária de 16 horas.",
  // },
  {
    name: "NR 12 e 18",
    value:
      " concluiu com aproveitamento o treinamento  de Segurança nos Trabalhos com Martelos Rompedores Elétricos e Pneumáticos de acordo com as NR’s 12 e 18, realizado em ((11 de setembro de 2023)), com carga horária de 08 horas.",
  },
  {
    name: "NR 12",
    value:
      " concluiu com aproveitamento o treinamento em Saúde e Segurança na Operação de Roçadeira de acordo com a NR 12, realizado em ((12 de junho de 2025)), com carga horária de 08 horas.",
  },
  {
    name: "NR 12 EP",
    value:
      " concluiu com aproveitamento o treinamento de Segurança na Operação De Máquinas e Equipamentos, de acordo com a NR12, realizado em ((15 de setembro de 2024)), com carga horária de 08 horas.",
  },
  {
    name: "NR 18",
    value:
      ", concluiu com aproveitamento o treinamento de formação em Segurança na montagem e desmontagem de andaimes nas modalidades: Andaimes multidirecionais, encaixe e tubos Rohr, de acordo com a NR 18, realizado nos dias (((18, 19, 20, 21 e 22 de agosto de 2025))) com carga horária de 40 horas, estando apto para desempenhar suas atividades para a empresa (((MVJ ANDAIMES - CNPJ: 46.393.993/0001-00))).",
  },
  {
    name: "NR 18 SIN",
    value:
      ", concluiu com aproveitamento o Treinamento de NR 18: Procedimentos e Sinalização de Segurança em Canteiro de Obras e Identificação de Riscos, de acordo com a NR 18, com carga horária de ((04 horas)). Realizado presencialmente em (( 15 de janeiro de 2000 )), ((em Apiaí/SP)) nas dependências da empresa (( Empresa X))",
  },
  {
    name: "NR 20 - 04H EAD",
    value:
      " concluiu com aproveitamento o treinamento de nível básico em Saúde e Segurança no Trabalho com Líquidos Inflamáveis e Combustíveis, Classe l de Instalação e com carga horária de 04 horas, de acordo com a NR-20. Realizado em ((07 de agosto de 2025)).",
  },
  {
    name: "NR 20 - 04H PRESENCIAL",
    value:
      "  concluiu com aproveitamento o treinamento de nível básico em Saúde e Segurança no Trabalho com Líquidos Inflamáveis e Combustíveis, Classe l de Instalação e com carga horária de 04 horas, de acordo com a NR-20. Realizado em ((07 de agosto de 2025)).",
  },
  // {
  //   name: "NR 34",
  //   value:
  //     " concluiu com aproveitamento o treinamento de Segurança nos Trabalhos a Quente de acordo com a NR 34, realizado em ((20 de abril de 2024)), com carga horária de 08 horas.",
  // },
  {
    name: "NR 35 - 08H",
    value:
      " concluiu com aproveitamento o treinamento em Saúde e Segurança nos Trabalhos em Altura de acordo com a NR 35, realizado em ((23 de abril de 2025)), com carga horária de 08 horas",
  },
  {
    name: "NR 35 - PRÁTICO 4H",
    value:
      " concluiu com aproveitamento o treinamento prático de Saúde e Segurança nos Trabalhos em Altura para Executantes de acordo com a NR 35, realizado em ((17 de outubro de 2024)), com carga horária de 04 horas.",
  },
  // ead
  {
    name: "NR 33 - INICIAL - 16H",
    value:
      "  concluiu com aproveitamento o treinamento inicial em Segurança nos Espaços Confinados segundo a NR 33, realizado nos dias ((26 e 27 de julho de 2025)), com carga horária de 16 horas, estando apto para desempenhar suas atividades para a empresa ((MVJ ANDAIMES - CNPJ: 46.393.993/0001-00)).",
  },
  {
    name: "NR 33 - EAD - 16H",
    value:
      " concluiu com aproveitamento o treinamento inicial em Segurança nos Espaços Confinados segundo a NR 33, realizado nos dias ((21 e 22 de maio de 2025)), com carga horária de 16 horas, estando apto para desempenhar suas atividades para a empresa ((XXXXX)) - CNPJ: ((XX.XXX.XXX/XXXX-XX)).",
  },
  {
    name: "NR 33 - PRÁTICO - 04H",
    value:
      " concluiu com aproveitamento o treinamento Prático em Saúde e Segurança no Trabalho em Espaço Confinado de acordo com a NR 33, realizado em ((13 de setembro de 2024)), com carga horária de 04 horas.",
  },
  {
    name: "NR 33 - RECICLAGEM - 08H",
    value:
      " concluiu com aproveitamento o treinamento de reciclagem em Saúde e Segurança nos Espaços Confinados segundo a NR 33, realizado no dia ((22 de maio de 2025)), com carga horária de 08 horas, estando apto para desempenhar suas atividades para a empresa ((XXXXX)) - CNPJ: ((XX.XXX.XXX/XXXX-XX)).",
  },
  {
    name: "NR 33 - SUPERVISOR INICIAL - 40H",
    value:
      " concluiu com aproveitamento o treinamento inicial de Supervisor de Espaço Confinado, com carga horária de 40 horas, de acordo com o NR-33. Realizado nos dias ((01, 02, 03, 04, 05 de junho de 2025)), nas dependências ((da CSN – Unidade Sorocaba/SP)).",
  },
  {
    name: "NR 33 - SUPERVISOR RECICLAGEM - 08H",
    value:
      " concluiu com aproveitamento o treinamento de reciclagem de Supervisor de Espaço Confinado, com carga horária de 08 horas, de acordo com o NR-33. Realizado no dia ((01 de junho de 2025)), nas dependências da ((CSN – Unidade Sorocaba/SP.))",
  },
  {
    name: "NR 34 - TRAB. A QUENTE - 08H",
    value:
      " concluiu com aproveitamento o treinamento de Saúde e Segurança nos Trabalhos a Quente de acordo com a NR 34, realizado em ((20 de abril de 2024)), com carga horária de 08 horas.",
  },
  {
    name: "NR 11 - EMPILHADEIRA - 08H RECICLAGEM",
    value:
      " concluiu com aproveitamento o treinamento de reciclagem em Saúde e Segurança na Operação de Empilhadeiras de acordo com as NR’s 11 e 12, realizado em ((30 de maio de 2025)) com carga horária de 08 horas.",
  },
  {
    name: "NR 11 - EMPILHADEIRA - 16H INICIAL",
    value:
      " concluiu com aproveitamento o treinamento de formação em Saúde e Segurança na Operação de Empilhadeiras de acordo com as NR’s 11 e 12, realizado em ((30 de maio e 02 de junho de 2025)) com carga horária de 16 horas.",
  },
  {
    name: "NR 11 - PONTE ROLANTE - 08H - RECICLAGEM",
    value:
      " concluiu com aproveitamento o treinamento de reciclagem em Segurança na Operação de Pórticos, Pontes rolantes, Monovias, e Talhas Elétricas de acordo com a NR 11, realizado em ((06 de maio de 2025)), com carga horária de 08 horas.",
  },
  {
    name: "NR 11 - PONTE ROLANTE 16H - INICIAL",
    value:
      " concluiu com aproveitamento o treinamento inicial em Segurança na Operação de Pórticos, Pontes rolantes, Monovias, e Talhas Elétricas de acordo com a NR 11, realizado em ((06 e 07 de maio de 2025)), com carga horária de 16 horas.",
  },
  {
    name: "",
    value: "",
  },
];

export const companies = [
  {
    name: "selecionar empresa",
    value: null,
    miniature: null,
  },
  {
    name: "ART FRITAS",
    value: "art_fritas",
    miniature: "art fritas miniatura",
  },
  {
    name: "SUPREMO",
    value: "supremo",
    miniature: "supremo miniatura",
  },
  {
    name: "CASA DO ADUBO",
    value: "casa_adubo",
    miniature: "casa adubo miniatura",
  },
  {
    name: "CSN",
    value: "csn",
    miniature: "csn miniatura",
  },
  {
    name: "DOM GIOVANI",
    value: "dom_giovani",
    miniature: "dom giovani miniatura",
  },
  {
    name: "INTERCEMENT",
    value: "intercement",
    miniature: "intercement miniatura",
  },
  {
    name: "RV MONT",
    value: "rv_mont",
    miniature: "rv mont miniatura",
  },
  {
    name: "MECBRUM",
    value: "mecbrum",
    miniature: "mecbrum miniatura",
  },
  {
    name: "MD TÉCNICA",
    value: "md",
    miniature: "md miniatura",
  },
  {
    name: "RA SERVICE",
    value: "ra",
    miniature: "ra miniatura",
  },
  {
    name: "MOVEX",
    value: "movex",
    miniature: "movex miniatura",
  },
  {
    name: "METAL AR",
    value: "metal_ar",
    miniature: "metal ar miniatura",
  },
  {
    name: "MVJ SERVICE",
    value: "mvj",
    miniature: "mvj miniatura",
  },
  {
    name: "AS RESINAS",
    value: "as_resinas",
    miniature: "as miniatura",
  },
  {
    name: "BBL ENGENHARIA",
    value: "bbl",
    miniature: "bbl miniatura",
  },
];
